import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type Preset = {
  id: string;
  name: string;
  template_type: string;
  settings: Record<string, unknown>;
  use_count: number;
  created_at: number;
};

export function usePresets() {
  return useQuery({
    queryKey: ['presets'],
    queryFn: () => api.get<{ presets: Preset[] }>('/api/app/presets'),
  });
}

export function useCreatePreset() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string; settings: Record<string, unknown>; template_type?: string }) =>
      api.post<{ preset: Preset }>('/api/app/presets', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['presets'] }),
  });
}

export function useDeletePreset() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.del<{ deleted: boolean }>(`/api/app/presets/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['presets'] }),
  });
}
